import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";


@Injectable({
   providedIn: 'root'
})
export class OrdineSlaveFactory {
   constructor(private serverSrv: ServerService,
               private dataSrv: DataService) {
   }
}

export class OrdineSlaveData {
   id?: number;
   ordine?: any;
   ordine_rif?: number;
   vendor_prod_var_instance?: any;
   pvendita_prod_var_instance?: any;
   total?: number; //prezzo_acquisto_netto
   total_gross?: number; //prezzo_acquisto_listino
   prezzo_vendita?:number;
   ricarico?:number;
   sconto?:number;
   ean?:number;
   qta?:number;
   qta_disp?:number;
   qta_reso_ordine?:number; // Indica la qta del reso dell'ordine
   riga?:number;
   qta_convalidata?:number;
   qta_resi_precedenti?:number; // Indica la qta del reso dell'ordine precedenti al reso selezionato
   qta_rimanente?:number;
   qta_reso?:number;
   qta_pvendita?:number;
   percentage?:number;
   barcodes?:[];
}

export class OrdineSlave {

   data:OrdineSlaveData = {}
   PROD_DISPLAY = ""

   constructor(data:OrdineSlaveData) {
      // assegno al mio oggetto data (è un json)
      if(!data) data = {}
      Object.assign(this.data, data)
      this.setProdottoDisplay();
   }

   static getProdDisplay(data){
      let name = data?.vendor_prod_var_instance?.p_variant?.prodotto?.brand__name || "Altro Prodotto";
      if (data?.vendor_prod_var_instance?.p_variant?.codice)
         name += " - " + data?.vendor_prod_var_instance?.p_variant?.codice;
      if (data?.vendor_prod_var_instance?.p_variant?.colore_str)
         name += " - (" + data?.vendor_prod_var_instance?.p_variant?.colore_str + ")";
      return name;
   }

   setProdottoDisplay(){
      this.PROD_DISPLAY = OrdineSlave.getProdDisplay(this.data)
   }

   public static VariabiliOrdine = [
      {value:'sco_flat', display:"Sconto in Valore Assoluto"},
      {value:'sco_perc', display:"Sconto in Valore Percentuale"},
      {value:'buo', display:"Buono Acquisto"},
      // {value:'res', display:"Selezione Manuale Resi"},
      // {value:'cor', display:"Selezione Manuale Corrieri"},
   ]

}
